import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedSitesContext, useSelectedSitesContext] = createGenericContext([]);
